module.exports = __webpack_public_path__ + "img/Image2.32682397.png";